<template>
    <div>
        <section id="back-section" class="mobile-container">
            <div @click="goBack" class="py-2 d-flex align-items-center" :class="'justify-content-' + justifyContent">
                <div v-if="type == 2"></div>
                <button class="btn btn-back d-flex align-items-center justify-content-between">
                    <span>Tilbage</span>
                    <span class="material-symbols-outlined">replay</span>
                </button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "BackSection",
    props: {
        url: {type: String, required: true},
        type: {type: String, required: true},
    },
    data() {
        return {
            justifyContent: 'end'
        }
    },
    created() {
        if (this.type == 2) {
            this.justifyContent = 'between'
        }

    },
    methods: {
        goBack() {
            window.location.href = this.url;
        },
    }
}

</script>

<style scoped>
.btn-back {
    width: 100px;
    padding-right: 0.25rem;
    padding-left: 0.25rem;
    color: #ffffff;
    border: 2px solid #ffffff;
    border-radius: 3px;
}
</style>
